import React from 'react'

const Version = ({ checkAllVersionTasks, disabled = false, checked = false, version = {} }) => {
    return (
        <div className="justify-between items-center">
            <div className="flex justify-start items-center">
                <input
                    disabled={disabled}
                    className="mr-1"
                    type="checkbox"
                    onChange={(e) => {checkAllVersionTasks(version)}}
                    checked={checked}
                />
                <div className="text-base">
                    <div className={`${disabled ? 'line-through' : ''}`}>
                    </div>
                        <div className={`${disabled ? 'line-through' : ''}`}>
                            { version.title }
                        </div>
                </div>
            </div>
        </div>
    );
}

export default Version;